import React from "react";

const ShowMe = () => {
  return (
    <div>
      <h1>BIG BEN SOLT</h1>
    </div>
  );
};

export default ShowMe;
